import React, { useState, useRef } from 'react';
import './RainbowText.css';

const RainbowText = ({ children }) => {
  const [hovered, setHovered] = useState(false);
  const touchTimer = useRef(null);
  const text = React.Children.toArray(children)
    .map(child => (typeof child === 'string' || typeof child === 'number' ? String(child) : ''))
    .join('');
  const chars = text.split('');

  const handleTouchStart = (e) => {
    e.preventDefault();
    if (touchTimer.current) clearTimeout(touchTimer.current);
    setHovered(true);
  };

  const handleTouchEnd = () => {
    touchTimer.current = setTimeout(() => setHovered(false), 600);
  };

  const total = chars.length;
  const spread = 80;
  const shift = 100;

  return (
    <span
      className={`rainbow-text${hovered ? ' rainbow-text--active' : ''}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      onTouchCancel={handleTouchEnd}
    >
      {chars.map((char, i) => {
        const pct = total > 1 ? (i / (total - 1)) * spread : 0;
        return (
          <span
            key={i}
            className="rainbow-text__char"
            style={{
              '--i': i,
              '--bg-from': `${pct}%`,
              '--bg-to': `${pct + shift}%`,
            }}
          >
            {char === ' ' ? '\u00A0' : char}
          </span>
        );
      })}
    </span>
  );
};

export default RainbowText;
